module.exports = __webpack_public_path__ + "static/media/truck.b1f2acef.svg";